export const CUSTOM_EVENT = {
  change_product_detail_tab: 'change_product_detail_tab',
  changed_product_detail_tab: 'changed_product_detail_tab',
  change_device_option: 'change_device_option',
  change_color_option: 'change_color_option',
  click_show_reviews: 'click_show_reviews',
  change_count_option: 'change_count_option',
  change_size_option: 'change_size_option',
};
